/**
 * Standard T-Hangar Row Template
 *
 * Creates a row of alternating T-shaped units within a rectangular
 * building envelope. Even-indexed units face south, odd face north.
 */

import { Warehouse } from 'lucide-react'
import type { BuildingTemplate } from '../types'
import { tHangarParamsSchema, DEFAULT_T_HANGAR_VALUES, type THangarParams } from './params'
import { generateBuilding, generateUnits } from './generate'

/**
 * Standard T-Hangar Row Template definition
 */
export const StandardTHangarTemplate: BuildingTemplate<THangarParams> = {
  id: 'standard_t_hangar',
  name: 'Standard T-Hangar Row',
  description: 'Linear row of alternating T-shaped units for GA aircraft',
  icon: Warehouse,
  buildingType: 't_hangar_row',

  generateBuilding,
  generateUnits,

  formSchema: tHangarParamsSchema,
  defaultValues: DEFAULT_T_HANGAR_VALUES,
}

// Re-export types and utilities
export { type THangarParams, tHangarParamsSchema, DEFAULT_T_HANGAR_VALUES } from './params'
export { calculateStepWidth, calculateUnitPitch, calculateTShapeArea } from './params'
export { generateBuilding, generateUnits } from './generate'
export {
  calculateRowLength,
  calculateBuildingDepth,
  calculateTHangarUnitOffsets,
  calculateTHangarLayout,
  isUnitSouthFacing,
  type THangarLayoutResult,
} from './calculations'
export {
  createTHangarEdges,
  shouldRenderTHangarEdge,
  type THangarEdgeSide,
  type THangarUnitEdge,
} from './edges'
